/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ImageResponse } from '../../models/image-response';
import { ImageUpdateRequest } from '../../models/image-update-request';

export interface UpdateImageProperties$Params {

/**
 * Identifier of the image
 */
  id: string;
      body: ImageUpdateRequest
}

export function updateImageProperties(http: HttpClient, rootUrl: string, params: UpdateImageProperties$Params, context?: HttpContext): Observable<StrictHttpResponse<ImageResponse>> {
  const rb = new RequestBuilder(rootUrl, updateImageProperties.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ImageResponse>;
    })
  );
}

updateImageProperties.PATH = '/images/{id}';
